export const fetchSlimSelect = () => import(/* webpackChunkName: "slim-select" */ 'slim-select');

export const fetchLightgallery = () =>
    Promise.all([
        import(
            'lightgallery'
            /* webpackChunkName: "lightgallery" */
        ),
    ]).then(([m]) => m);
